<section class="loading-bg" *ngIf="!!show">
  <div class="bouncer">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</section>
